import * as React from 'react';
import { Dialog, DialogFooter, DialogType, PrimaryButton, DefaultButton } from 'office-ui-fabric-react';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const DialogConfirm = props => {
  return /*#__PURE__*/_jsx(Dialog, {
    hidden: !props.isOpen,
    onDismiss: props.onCancelClick,
    dialogContentProps: {
      type: DialogType.normal,
      title: props.title,
      subText: props.subText
    },
    modalProps: {
      isBlocking: false,
      styles: {
        main: {
          maxWidth: 650
        }
      }
    },
    children: /*#__PURE__*/_jsxs(DialogFooter, {
      children: [/*#__PURE__*/_jsx(DefaultButton, {
        onClick: props.onCancelClick,
        text: "Cancel"
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        onClick: props.onConfirmClick,
        text: props.actionButtonName || 'Yes'
      })]
    })
  });
};